var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value === _vm.trueValue)?_c('span',[_vm._v(_vm._s(_vm.trueText))]):(_vm.value === _vm.falseValue)?_c('span',[_vm._v(_vm._s(_vm.falseText))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }